import React, { useState } from 'react';

export default function ValueGenerationCalculator({volumeDaily}) {

  const [dailyVolume, setDailyVolume] = useState(volumeDaily);
  const [feeRate, setFeeRate] = useState(6);
  const feeSplits = {Reflection: 1, UFOBurn: 1, PTGCBurn: 1, Liquidity: 3 };
  const timeFrames = {"1 Day": 1, "1 Week": 7, "1 Month": 30, "6 Months": 180, "1 Year": 365, "5 Year": 1825};

  const calculateBreakdown = (days) => {
    const totalVolume = dailyVolume * days;
    const totalFees = totalVolume * (feeRate / 100);

    const categoryValues = {};
    for (const [label, pct] of Object.entries(feeSplits)) {
      categoryValues[label] = totalVolume * (pct / 100);
    }
    
    return {
      totalFees,
      ...categoryValues
    };
  };

  return (
    <>
      <div className="container containerstatsALL statsALL">
        <div className="burnSec bSRIN overHide subcontent">
            <div className="snPortal">
              <div className="SRTOP d-flex flex-wrap justify-content-between align-items-center">
              <h2 className="mb-0">Value Generation Calculator</h2>
                <div className="iconSR">
                  <img src="./images/MathOperations.svg" className="img-fluid" alt="icon" />
                </div>
              </div>
            </div>

          <div className="row m-0">
            <div className="col-md-12 col-xl-12 p-0 CalculatorTop">
              <div className="row m-0">
                <div className="col-md-6 col-xl-6 p-0 borderRight">
                  <div className="boxes2">
                    <div className="d-flex gap-2 flex-wrap align-items-center">
                      <label className="fInter mb-1" htmlFor="burnTodayRange">Daily Transaction Volume ($)</label>
                    </div>
                    <input
                      type="text"
                      value={
                        dailyVolume === ""
                          ? ""
                          : Number(dailyVolume.toString().replace(/,/g, "")).toLocaleString("en-US", {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0
                            })
                      }
                      onChange={(e) => {
                        const raw = e.target.value.replace(/,/g, "");
                        if (raw === "") {
                          setDailyVolume("");
                          return;
                        }
                        if (isNaN(raw)) return;
                        setDailyVolume(raw.toString());
                      }}
                      className="input w-100"
                      placeholder="0.00"
                      style={{
                        background: "rgb(0 0 0 / 33%)",
                        padding: "10px",
                        width: "100%",
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-6 col-xl-6 p-0">
                  <div className="boxes2">
                    <span className="fInter mb-1">Transaction Fee </span>
                    <h2 className="speacialH2 mt-2">{feeRate}%</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="statsALL">
          <div className=" subcontent overHide mt-4">
            <div className="SRTOP borderBottom  d-flex flex-wrap justify-content-between align-items-center">
              <div className="snPortal w-100">
                <h2 className="mb-0">Result</h2>
              </div>
            </div>

            <div className="row">
              {Object.entries(timeFrames).map(([label, days]) => {
                const breakdown = calculateBreakdown(days);
                return (
                  <div key={label} className="col-xl-4 col-lg-4 borderBottom borderRight">
                    <div className="snPortal">
                      <div className="d-flex flex-wrap justify-content-between gap-2">
                        <p><strong>Total Fees:</strong> ${breakdown.totalFees.toLocaleString('en-US', { maximumFractionDigits: 2 })}</p>
                        <p><b>{label}</b></p>
                      </div>
                      <p className="mb-1 perVal d-flex justify-content-between"><span>Reflection:</span> ${breakdown.Reflection.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                      <p className="mb-1 perVal d-flex justify-content-between"><span>UFO Buy & Burn:</span> ${breakdown.UFOBurn.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                      <p className="mb-1 perVal d-flex justify-content-between"><span>PTGC Buy & Burn:</span> ${breakdown.PTGCBurn.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                      <p className="mb-1 perVal d-flex justify-content-between"><span>UFO LPing:</span> ${breakdown.Liquidity.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
       </div>
      </div>
    </>
  );
}
